import { isValidPersianAlpha } from 'utils/custom-validation';
import * as Yup from 'yup';

const AddBankSchema = Yup.object().shape({
    iban: Yup.string()
        .required('وارد کردن شماره شبا الزامی است')
        .length(26, 'فیلد شماره شبا باید دقیقاً 26 کاراکتر با احتساب IR باشد')
        .test('is-valid-iran-iban', 'شماره شبا معتبر نیست', (value) => {
            if (!value) return false;
            const iranIbanRegex = /^IR[0-9]{24}$/;
            return iranIbanRegex.test(value);
        }),

    facility: Yup.boolean(),

    fullname: Yup.string().when('facility', {
        is: true,
        then: (schema) =>
            schema
                .required(
                    'فیلد نام و نام خانوادگی در صورت شریک تجاری بودن حساب الزامی است',
                )
                .min(3, 'فیلد نام و نام خانوادگی باید حداقل 3 کاراکتر باشد')
                .max(64, 'فیلد نام و نام خانوادگی باید حداکثر 64 کاراکتر باشد')
                .matches(isValidPersianAlpha, 'فقط حروف فارسی مجاز است'),
    }),
});

export default AddBankSchema;
